import _isFunction from 'lodash/isFunction'; /**
                                              * @author Kuitos
                                              * @homepage https://github.com/kuitos/
                                              * @since 2017-09-13
                                              */

import { postConstructSymbol } from '../meta';
export default function execPostConstruct(instance) {
    var fn = instance[postConstructSymbol];
    if (_isFunction(fn)) {
        fn.call(instance);
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mmlpx/esm/core/dependency-inject/initializers/execPostConstruct.js
// module id = null
// module chunks = 